import { render, staticRenderFns } from "./EventsTab.vue?vue&type=template&id=58201ed8&scoped=true"
import script from "./EventsTab.vue?vue&type=script&lang=js"
export * from "./EventsTab.vue?vue&type=script&lang=js"
import style0 from "./EventsTab.vue?vue&type=style&index=0&id=58201ed8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58201ed8",
  null
  
)

export default component.exports